var _circle, _path, _path2, _path3, _path4, _path5, _path6, _circle2, _path7, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _line, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49,
    r: 49,
    fill: "url(#paint0_linear_4318_5188)",
    fillOpacity: 0.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8784 74.8108L34.8784 74.8108C34.9225 74.8168 34.9664 74.8197 35.0097 74.8197C35.3187 74.8197 35.6127 74.6725 35.7974 74.4182L41.6241 66.3956H62.4941C65.347 66.3956 67.6677 64.0749 67.6677 61.2219V60.8133H68.0763C70.9293 60.8133 73.25 58.4926 73.25 55.6396V32.9237C73.25 30.0707 70.9293 27.75 68.0763 27.75H34.5059C31.653 27.75 29.3323 30.0707 29.3323 32.9237V33.3323H28.9237C26.0707 33.3323 23.75 35.653 23.75 38.5059V61.2219C23.75 64.0749 26.0707 66.3956 28.9237 66.3956H31.1849L34.0976 74.187C34.2231 74.5227 34.5231 74.7625 34.8784 74.8108ZM65.7205 61.2219C65.7205 63.0007 64.2729 64.4483 62.4941 64.4483H41.1279C40.8162 64.4483 40.5233 64.5976 40.3402 64.8498L35.2869 71.8074L32.7723 65.081C32.6301 64.7005 32.2666 64.4483 31.8604 64.4483H28.9237C27.1448 64.4483 25.6973 63.0007 25.6973 61.2219V38.5059C25.6973 36.7271 27.1448 35.2795 28.9237 35.2795H62.4941C64.2729 35.2795 65.7205 36.7271 65.7205 38.5059V61.2219ZM71.3027 55.6396C71.3027 57.4184 69.8552 58.866 68.0763 58.866H67.6677V38.5059C67.6677 35.653 65.347 33.3323 62.4941 33.3323H31.2795V32.9237C31.2795 31.1448 32.7271 29.6973 34.5059 29.6973H68.0763C69.8552 29.6973 71.3027 31.1448 71.3027 32.9237V55.6396Z",
    fill: "#167092",
    stroke: "#167092",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0918 40C34.0918 38.8954 34.9872 38 36.0918 38H65.8205V64.8034H46.9103L40.5 65L35.5 71.5L33 65.5L28 64.8034V48.2308C28 47.1262 28.8954 46.2308 30 46.2308H32.0918C33.1964 46.2308 34.0918 45.3353 34.0918 44.2308V40Z",
    fill: "#167092",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0417 48.825C39.26 49.0433 39.6139 49.0433 39.8322 48.825L41.2566 47.4006C41.3542 47.303 41.5125 47.303 41.6101 47.4006L43.0345 48.825C43.2528 49.0433 43.6067 49.0433 43.825 48.825C44.0433 48.6067 44.0433 48.2528 43.825 48.0345L42.4006 46.6101C42.303 46.5125 42.303 46.3542 42.4006 46.2566L43.825 44.8322C44.0433 44.6139 44.0433 44.26 43.825 44.0417C43.6067 43.8234 43.2528 43.8234 43.0345 44.0417L41.6101 45.4661C41.5125 45.5637 41.3542 45.5637 41.2566 45.4661L39.8322 44.0417C39.6139 43.8234 39.26 43.8234 39.0417 44.0417C38.8234 44.26 38.8234 44.6139 39.0417 44.8322L40.4661 46.2566C40.5637 46.3542 40.5637 46.5125 40.4661 46.6101L39.0417 48.0345L39.2185 48.2113L39.0417 48.0345C38.8234 48.2528 38.8234 48.6067 39.0417 48.825Z",
    fill: "#167092",
    stroke: "#167092",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3972 48.825C50.6154 49.0433 50.9694 49.0433 51.1876 48.825L52.612 47.4006C52.7097 47.303 52.8679 47.303 52.9656 47.4006L54.39 48.825C54.6083 49.0433 54.9622 49.0433 55.1804 48.825C55.3987 48.6067 55.3987 48.2528 55.1804 48.0345L53.7561 46.6101C53.6584 46.5125 53.6584 46.3542 53.7561 46.2566L55.1804 44.8322C55.3987 44.6139 55.3987 44.26 55.1804 44.0417C54.9622 43.8234 54.6083 43.8234 54.39 44.0417L52.9656 45.4661C52.8679 45.5637 52.7097 45.5637 52.612 45.4661L51.1876 44.0417C50.9694 43.8234 50.6154 43.8234 50.3972 44.0417C50.1789 44.26 50.1789 44.6139 50.3972 44.8322L51.8215 46.2566C51.9192 46.3542 51.9192 46.5125 51.8215 46.6101L50.3972 48.0345L50.5739 48.2113L50.3972 48.0345C50.1789 48.2528 50.1789 48.6067 50.3972 48.825Z",
    fill: "#167092",
    stroke: "#167092",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6226 58.3505L40.7752 58.2013C44.3577 54.7002 50.1002 54.767 53.6003 58.3505V58.3505",
    stroke: "#167092",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0771 38H65.8207V62.8034C65.8207 63.908 64.9253 64.8034 63.8207 64.8034H62.0771V38Z",
    fill: "#167092",
    fillOpacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.047,
    cy: 33.047,
    r: 8.29701,
    fill: "white",
    fillOpacity: 0.92,
    stroke: "#167092",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8173 36.2765C65.046 36.5052 65.4168 36.5052 65.6456 36.2765L67.7994 34.1227C67.9361 33.986 68.1577 33.986 68.2943 34.1227L70.4481 36.2765C70.6769 36.5052 71.0477 36.5052 71.2765 36.2765C71.5052 36.0477 71.5052 35.6769 71.2765 35.4481L69.1227 33.2943C68.986 33.1577 68.986 32.9361 69.1227 32.7994L71.2765 30.6456C71.5052 30.4168 71.5052 30.046 71.2765 29.8173C71.0477 29.5885 70.6769 29.5885 70.4481 29.8173L68.2943 31.9711C68.1577 32.1077 67.9361 32.1077 67.7994 31.9711L65.6456 29.8173C65.4168 29.5885 65.046 29.5885 64.8173 29.8173C64.5885 30.046 64.5885 30.4168 64.8173 30.6456L66.9711 32.7994C67.1077 32.9361 67.1077 33.1577 66.9711 33.2943L64.8173 35.4481C64.5885 35.6769 64.5885 36.0477 64.8173 36.2765Z",
    fill: "#FF8300",
    stroke: "#FF8300",
    strokeWidth: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2479,
    cy: 70.2479,
    r: 1.24786,
    fill: "#167092"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.0003,
    cy: 31.3333,
    r: 1.24786,
    fill: "#167092"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.265,
    cy: 19.4786,
    r: 1.24786,
    fill: "#167092"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9915,
    cy: 46.9317,
    r: 1.24786,
    fill: "#167092"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.2479,
    cy: 11.2479,
    r: 1.24786,
    fill: "#167092"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.2565,
    cy: 67.5214,
    r: 1.99573,
    stroke: "#167092"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.111,
    cy: 20.7264,
    r: 1.99573,
    stroke: "#167092"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 79,
    x2: 89.4872,
    y2: 79,
    stroke: "#167092",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3077 51.2991V53.8543H80.7524",
    stroke: "#167092",
    strokeWidth: 0.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4372 51.2993V53.8546H87.9924",
    stroke: "#167092",
    strokeWidth: 0.8
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3077 58.5391V55.9838H80.7524",
    stroke: "#167092",
    strokeWidth: 0.8
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4372 58.5391V55.9838H87.9924",
    stroke: "#167092",
    strokeWidth: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4318_5188",
    x1: 49,
    y1: 0,
    x2: 49.5632,
    y2: 117.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009B94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009B94",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotPost);
export default __webpack_public_path__ + "static/media/notPost.814aa6f138c31cc9f8c0f44c12d09917.svg";
export { ForwardRef as ReactComponent };